<template>
    <div class="house-filter" :class="{ open: openState}">
        <div class="house-filter-wrap" v-bind:style="{'height': myHeight}">
            <div class="filter-title">
                <img src="@/assets/img/icon/filter_gray.svg" alt="">
                篩選
                <span v-show="filterState" class="clear-filter" @click="setFilterDefault">
                    清除篩選
                </span>
            </div>
            <div class="default">
                <div v-if="isAllGroup" class="title level1-title-font">業務分群</div>
                <rent-select class="select-scroll" v-if="isAllGroup" refName="orgGroup" style="margin-bottom: 16px;" selectMsg="全部" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                    <ul>
                        <li v-for="(item, index) in groupList" :key="index" :data-id="item.id" :data-name="item.groupName">
                            {{item.groupName}}
                        </li>
                    </ul>
                </rent-select>
                <div class="title  level1-title-font">業務</div>
                <rent-select class="select-scroll" refName="member" selectMsg="全部" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault || isGroupChange">
                    <ul>
                        <li v-for="(item, index) in memberList" :key="index" :data-id="item.userCid" :data-name="item.name">
                            {{item.name}}
                        </li>
                    </ul>
                </rent-select>
            </div>
            <div class="default rent">
                <div class="title level1-title-font">獎金</div>
                <vue-slider v-model="filter.bonus" :min="0" :max="100000" :width="214" :height="2" tooltip="always" :tooltip-placement="'bottom'" :tooltip-formatter="val => numValue(val)" :enableCross="true"/>
            </div>
            <!-- <div class="result">
                <div class="view-result" @click="filterClose">
                    查看搜尋結果  {{filterTotal}}
                </div>
            </div> -->
        </div>
        <span class="close" @click="filterClose">
            <img src="@/assets/img/icon/cross_white.svg" alt="">
        </span>
    </div>
</template>
<script>
import VueSlider from 'vue-slider-component'
import '@/assets/css/rent.css'
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import VueRangeSlider from 'vue-range-component'
import DatePicker from 'vue2-datepicker';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            openState: this.isOpen,
            filter: {
                group: '',
                member: '',
                bonus: [0, 100000],
            },
            // isDefault: false,
            isGroupChange: true,
            filterState: false,
            filterResultTotal: 0,
            myHeight: (window.innerHeight) + 'px',
        }
    },
    created () {
        this.formatter = value => {
            if( value >= 100000){
                return `$${value}+`
            }else{
                return `$${value}`
            }
        }
    },
    mounted () {
        if(!this.isAllGroup){
            this.$store.dispatch('getBizMemberByGroupList', this.groupId)
        }
    },
    destroyed () {
        this.$store.dispatch('setBizTaskUnpaidMgtFilterDefault')
    },
    props: {
        isOpen: Boolean,
        taskHouseInfo: Object
    },
    watch: {
        isOpen (val) {
            this.openState = val
        },
        filter: {
            handler: function (value) {
                // this.$emit('changeFilter', this.filter)
                this.$store.dispatch('setBizTaskUnpaidMgtFilterQuery', value)
                this.filterState = true
            },
            deep: true
        },
        isDefault: function (val) {
            if(val){
                this.filterState = false
            }
        }
    },
    methods: {
        setFilterDefault: function () {
            // this.filter = {
            //     group: '',
            //     member: '',
            //     status: '',
            //     payway: '',
            //     bonus: [0, 100000],
            // },
            // this.isDefault = true
            // setTimeout(()=>{
            //     this.filterState = 0
            //     this.isDefault = false
            // },100)
            this.$store.dispatch('setBizTaskUnpaidMgtFilterDefault')
        },
        filterClose: function () {
            this.$emit('filterClose', false);
        },
        getSelectId: function (value) {
            this.filterState = 1
            // this.isDefault = false
            if( value.ref == 'orgGroup' ){
                this.filter.group = value.name
                this.$store.dispatch('getBizMemberByGroupList',(value.id))
                this.isGroupChange = true
                this.filter.member = ''
            }else if( value.ref == 'member' ){
                this.filter.member = value.name
                this.isGroupChange = false
            }
        },
        numValue: function (val) {
            if( val == '100000' ){
                return '$'+this.toCurrency(val)+'+'
            }else{
                return '$'+this.toCurrency(val)
            }
        },
    },
    computed: {
        ...mapGetters({
            filterTotal: 'GET_BIZ_TASK_UNPAID_MGT_FILTER_RESULT_TOTAL',
            groupId: 'GET_BIZ_GROUP_ID',
            isAllGroup: 'GET_BIZ_IS_ALL_GROUP',
            groupList: 'GET_ORG_GROUP_LIST',
            memberList: 'GET_ORG_MEMBER_BY_GROUP_LIST',
            isDefault: 'GET_BIZ_TASK_UNPAID_MGT_FILTER_DEFAULT',
        })
    },
    components: {
        RentSelect,
        VueSlider,
        DatePicker,
    }
}
</script>
<style lang="scss" scoped>
    .house-filter{
        position: fixed;
        width: 279px;
        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
        background-color: #ffffff;
        // height: 100%;
        top: 0px;
        right: -350px;
        transition: all 1s ease-in-out;
        z-index: 10;
        .house-filter-wrap{
            position: relative;
            overflow-x: hidden;
            padding-bottom: 100px;
            &::-webkit-scrollbar {
                display: none;
            }
            .default{
                padding: 20px;
                border-bottom: 1px solid #f0f0f0;
                .title{
                    margin-bottom: 16px;
                }
            }
            .filter-title{
                display: flex;
                align-items: center;
                padding: 24px;
                color: #a8a5a4;
                border-bottom: 1px solid #f0f0f0;
                img{
                    margin-right: 8px;
                }
                .clear-filter{
                    position: absolute;
                    cursor: pointer;
                    font-size: 12px;
                    color: #ff9275;
                    top: 30px;
                    right: 34px;
                }
            }
            .location{
                .group{
                    display: flex;
                    .biz-rent-select:nth-child(1){
                        margin-right: 10px;
                    }
                    .biz-rent-select{
                        width: 75px;
                        height: 18px;
                    }
                }
            }
            .period,
            .rent-date{
                .mx-datepicker {
                    width: 230px;
                    .mx-input-wrapper{
                        .mx-input{
                            height: 46px;
                            border-radius: 4px;
                            border: solid 1px #e0dfde;
                            color: #a8a5a4;
                            padding: 13px 16px;
                            box-shadow: none;
                        }
                        .mx-icon-calendar,
                        .mx-icon-clear{
                            right: 18px;
                        }
                    }
                }
                .mx-datepicker.active{
                    input{
                        border: 1px solid #676362 !important;
                        color: #676362 !important;
                    }
                    i{
                        color: #676362;
                    }
                }
                .mx-datepicker:hover{
                    .mx-input-wrapper{
                        .mx-input{
                            border: 1px solid #676362 !important;
                            color: #676362 !important;
                        }
                    }
                }
            }
            .deposit,
            .rent{
                padding-bottom: 40px;
            }
            .result{
                position: absolute;
                width: 100%;
                height: 76px;
                bottom: 0px;
                display: flex;
                align-items: center;
                justify-content: center;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                .view-result{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #ffffff;
                    font-weight: 500;
                    width: 231px;
                    height: 44px;
                    border-radius: 4px;
                    background-color: #ff9275;
                    cursor: pointer;
                }
            }
        }
        .close{
            position: absolute;
            width: 30px;
            height: 44px;
            background-color: #ff9275;
            border-radius: 10px 0 0 10px;
            left: -30px;
            top: 50%;
            transform: translateY(-50%);
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                cursor: pointer;
            }
        }
    }
    .house-filter.open{
        right: 0px;
    }
    // @media screen and (max-width: 1280px) {
    //     .house-filter.open{
    //         right: 24px;
    //     }
    // }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/taskMgt/taskUnpaid/taskUnpaidFilter.vue